<template>
	<div>
		<el-form :inline="true" style="border-bottom: 1px #eee solid;">
			<el-form-item label="搜索">
				<el-input v-model="nameSearch" placeholder="按名称搜索" size="medium">
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="search" size="medium">搜索</el-button>
			</el-form-item>
		</el-form>

		<el-table v-loading="loading" :data="data" height="450px">
			<el-table-column prop="name" label="工艺参数组名"></el-table-column>
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
					<el-popover placement="right" width="450" trigger="click">
						<TechDetails :groupId="currentGroupId" v-if="scope.row._id.$oid == currentGroupId" />
						<el-button type="text" slot="reference" size="mini" @click="view(scope.row)">查看</el-button>
					</el-popover>

					<el-button style="margin-left:20px;" size="mini" @click="set(scope.row)">设置</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { techGroupRequest } from '@/network/requests/techGroup'
	import TechDetails from './TechDetails'
	export default {
		components: {
			TechDetails,
		},
		data() {
			return {
				data: [],
				currentGroupId: '',
				loading: false,
				nameSearch: '',
			}
		},
		methods: {
			/**
			 * 搜索。
			 */
			search() {
				this.getTeachGroups({ name: { $regex: this.nameSearch } })
			},
			/**
			 * 获取参数组。
			 */
			getTeachGroups(filter) {
				this.loading = true
				techGroupRequest
					.queryAll(filter)
					.then(res => {
						this.data = res
					})
					.finally(() => {
						this.loading = false
					})
			},
			/**
			 * 设置参数组。
			 */
			set(row) {
				this.$emit('select', {
					id: row._id.$oid,
					name: row.name,
				})
			},
			/**
			 * 查看参数信息。
			 */
			view(row) {
				this.currentGroupId = row._id.$oid
			},
		},
		created() {
			this.getTeachGroups(undefined)
		},
	}
</script>

<style></style>
